import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

import { useModalStore } from 'Helpers/modal';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheModal',
  setup(__props) {

const { modalList } = useModalStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modalList), (modalData, index) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent(modalData.component), _mergeProps({
      key: index,
      show: "",
      ref_for: true
    }, { ...modalData.props, ...modalData.callbacks }), null, 16))
  }), 128))
}
}

})